// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEmployerCalendarEventDto } from './IEmployerCalendarEventDto';
import {
    IEmployerCalendarEventDtoFromJSON,
    IEmployerCalendarEventDtoFromJSONTyped,
    IEmployerCalendarEventDtoToJSON,
    IEmployerCalendarEventDtoToJSONTyped,
} from './IEmployerCalendarEventDto';

/**
 * 
 * @export
 * @interface IEmployerCalendarEventsResponseDto
 */
export interface IEmployerCalendarEventsResponseDto {
    /**
     * 
     * @type {Array<IEmployerCalendarEventDto>}
     * @memberof IEmployerCalendarEventsResponseDto
     */
    events?: Array<IEmployerCalendarEventDto>;
}

/**
 * Check if a given object implements the IEmployerCalendarEventsResponseDto interface.
 */
export function instanceOfIEmployerCalendarEventsResponseDto(value: object): value is IEmployerCalendarEventsResponseDto {
    return true;
}

export function IEmployerCalendarEventsResponseDtoFromJSON(json: any): IEmployerCalendarEventsResponseDto {
    return IEmployerCalendarEventsResponseDtoFromJSONTyped(json, false);
}

export function IEmployerCalendarEventsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployerCalendarEventsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(IEmployerCalendarEventDtoFromJSON)),
    };
}

export function IEmployerCalendarEventsResponseDtoToJSON(json: any): IEmployerCalendarEventsResponseDto {
    return IEmployerCalendarEventsResponseDtoToJSONTyped(json, false);
}

export function IEmployerCalendarEventsResponseDtoToJSONTyped(value?: IEmployerCalendarEventsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(IEmployerCalendarEventDtoToJSON)),
    };
}

